import React             from 'react';
import PropTypes         from 'prop-types';

/* *********************************************************************************** */
/* **********                                                               ********** */
/* **********                               Spoil                           ********** */
/* **********                                                               ********** */
/* *********************************************************************************** */

export class Spoil extends React.Component {

    /* ------------ */
    /* Constructeur */
    /* ------------ */

    constructor(props){
        super(props);
        this.state = {
            survol : false,
        }

        this.survol    = this.survol.bind    (this);
        this.finSurvol = this.finSurvol.bind (this);
    }

    /* --------------------------------- */
    /* Survol ou non de la zone de texte */
    /* --------------------------------- */

    survol    ()    { this.setState ( {survol : true}  ); }
    finSurvol ()    { this.setState ( {survol : false} ); }

    /* ---------------------- */
    /* Affichage du composant */
    /* ---------------------- */

    render()
    {
        /* ------------------ */
        /* Définition des CSS */
        /* ------------------ */

        const styleTexte = this.state.survol ? {...this.props.style} : {...this.props.style, backgroundColor : "#AC8F63", color : "#AC8F63" };

        /* ------------------- */
        /* Renvoi du composant */
        /* ------------------- */

        return ( <div style={{display:'inline-block'}}
                        onMouseOver = {()=>this.survol()} 
                        onMouseOut = {()=>this.finSurvol()} 
                    >
                    {this.props.blanc && <React.Fragment>&nbsp;</React.Fragment>}
                    <div style={styleTexte} >
                        {this.props.texte}
                    </div>    
                    {this.props.blanc && <React.Fragment>&nbsp;</React.Fragment>}

            </div>  
        );
    }
}

/* ------------------------------------ */
/* Définition de la structure des props */
/* ------------------------------------ */

Spoil.defaultProps = {
    blanc  : true,
    texte  : '',
    style  : {
        display    : 'inline-block',
        color      : '#000000',
        fontSize   : "1.0em",
        fontFamily : "Arial"
    }
}

Spoil.propTypes = {
    blanc : PropTypes.bool,
    texte : PropTypes.string.isRequired,
    style : PropTypes.object
}


// WEBPACK FOOTER //
// ./src/components/commun/Spoil.js